<template>
    <div class="container auth-container">
        <div class="container-inner">
            <div class="reg-auth flex">
                <img src="/assets/images/auth-logo.svg" alt="">
                <div
                    class="reg-auth__wrap flex"
                    :class="showRegForm ? 'reg' : ''"
                >
                    <form class="reg-auth__form">
                        <div class="reg-auth__form-inner">
                            <!-- title -->
                            <div class="title">Личный кабинет</div>
                            <!-- switch -->
                            <div class="reg-auth__switch flex">
                                <a
                                    href="#"
                                    :class="!showRegForm && !showClientLogin ? 'active' : ''"
                                    @click="showRegForm = false; showClientLogin = false"
                                >Вход</a>
                                <a
                                    href="#"
                                    :class="showRegForm && !showClientLogin ? 'active' : ''"
                                    @click="showRegForm = true; showClientLogin = false"
                                >Регистрация</a>
                                <span
                                    class="switch__pointer"
                                    :class="showRegForm && !showClientLogin ? 'active-reg' : ''"
                                ></span>
                            </div>
                            <auth-from
                                v-if="!showRegForm && !showClientLogin"
                                :show-client-login-link="showClientLoginOption"
                                @client-login="showClientLogin = true"
                            />
                            <client-login-form
                                v-if="showClientLogin"
                                :is-auth-mp="isAuthMp"
                                @back-to-phone-login="showClientLogin = false; showRegForm = false"
                                @switch-to-phone-login="showClientLogin = false; showRegForm = false"
                                @switch-to-register="showClientLogin = false; showRegForm = true"
                            />
                            <reg-form
                                v-if="showRegForm && !showClientLogin"
                                @backAuth="getValue"
                            />
                        </div>
                    </form>
                    <div v-if="showSidePanel" class="reg-auth__side flex">
                        <p>Мобильное приложение для оплаты и передачи показаний</p>
                        <div class="reg-auth__line">
                            <a target="_blank" href="https://apps.apple.com/ru/app/%D0%BB%D1%8D%D1%81%D0%BA-%D0%BB%D0%B8%D1%87%D0%BD%D1%8B%D0%B9-%D0%BA%D0%B0%D0%B1%D0%B8%D0%BD%D0%B5%D1%82-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0/id1136740155">
                                <img src="/assets/images/apple-store.svg" alt="">
                            </a>
                            <img src="/assets/images/apple.png" alt="">
                        </div>
                        <div class="reg-auth__line">
                            <a target="_blank" href="https://play.google.com/store/apps/details?id=ru.lesk.mobapp">
                                <img src="/assets/images/google-play.svg" alt="">
                            </a>
                            <img src="/assets/images/google.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer-block />
    </div>
</template>

<script>
import AuthForm from "@/components/AuthReg/AuthForm"
import ClientLoginForm from "@/components/AuthReg/ClientLoginForm"
import RegForm from "@/components/AuthReg/RegForm"

export default {
    name: 'auth-reg-window',
    components: {
        AuthForm,
        ClientLoginForm,
        RegForm
    },
    props: {
        showSidePanel: {
            type: Boolean,
            default: true
        },
        showClientLoginOption: {
            type: Boolean,
            default: true
        },
        isAuthMp: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showRegForm: false,
            showClientLogin: false
        }
    },
    computed: {
        regErrors() {
            if (this.$store.state.authErrors)
                this.setInputDisabled(false)

            return this.$store.state.authErrors
        },
    },
    methods: {
        getValue(e) {
            this.showRegForm = false
        }
    }
}
</script>